export const MAPPED_CATEGORY_TO_CARD_STYLE_COLOR = {
  'local-producers': 'localProducersColor',
  experiences: 'experiencesColor',
  'farm-to-fork-dining': 'farmToForkDiningColor',
  'producers-places': 'localProducerPlacesToStayColor',
  markets_events: 'marketFestivalsAndCountryShowsColor',
  'shop-and-delivery-boxes': 'shopsDeliveryBoxesColor',
  // Shop / digital downloads (default-download listing types)
  files: 'shopsDeliveryBoxesColor',
};

export const MAPPED_CATEGORY_TO_CARD_STYLE_CONTENT = {
  'local-producers': 'EditListingStyleForm.localProducersContent',
  experiences: 'EditListingStyleForm.experiencesContent',
  'farm-to-fork-dining': 'EditListingStyleForm.farmToForkDiningContent',
  'producers-places': 'EditListingStyleForm.localProducerPlacesToStayContent',
  markets_events: 'EditListingStyleForm.marketFestivalsAndCountryShowsContent',
  'shop-and-delivery-boxes': 'EditListingStyleForm.shopsDeliveryBoxesContent',
  files: 'EditListingStyleForm.shopsDeliveryBoxesContent',
};
